module.exports = __webpack_public_path__ + "static/img/BU02PB-5.cca4e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB-5.jpg
// module id = bWBf
// module chunks = 1